/* eslint-disable react/display-name */
import React, { useEffect } from 'react'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { Card, Col, Row } from 'antd'
import { numberWithComma } from 'helpers/format'
import { connect, useDispatch } from 'react-redux'
import { selectMemberPointInfo } from 'Store/member-point/selector'
import RootState from 'typings/RootState'
import { getMemberPointInfoAPI } from 'Store/member-point/api'
import { MemberPoinInfoReq } from 'Store/member-point/types'
import { selectCurrentUser } from 'Store/user/selector'

type Props = {
  id?: number
  visible?: boolean
} & ReduxProps

const PointSummary: React.FunctionComponent<Props> = props => {
  const { pointInfo, currentUser, id = 0, visible = false } = props
  const detail = pointInfo?.data

  const dispatch = useDispatch()

  const onGetDetail = (): void => {
    const req: MemberPoinInfoReq = {
      id,
    }
    dispatch(getMemberPointInfoAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  useEffect(() => {
    // get detail on "edit" mode
    if (visible && id > 0) {
      onGetDetail()
    }
  }, [visible])

  return (
    <BoxWrapper>
      <Row gutter={[16, 16]} justify="space-between" align="top">
        <Col md={12} xs={24}>
          <BoxTitle>{pointInfo?.data?.fullname || ''}</BoxTitle>
          <Tel>{pointInfo?.data?.tel || ''}</Tel>
        </Col>
        <Col xs={24} md={12}>
          <PointWrapper>
            <Tel>คะแนนปัจจุบัน</Tel>
            <Point>{numberWithComma(detail?.point || 0)}</Point>
            <PointUsed>คะแนนที่ใช้ไปแล้ว {numberWithComma(detail?.point_used || 0)} คะแนน</PointUsed>
          </PointWrapper>
        </Col>
      </Row>
    </BoxWrapper>
  )
}

const BoxWrapper = styled(Card)`
  width: 100%;
  border-radius: 10px;
  margin-bottom: 10px;
  background: ${(props: { theme: MyTheme }): string => props.theme.colors.backgroundGradient};
`
const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.h2sm};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const Tel = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body2};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const Point = styled.span`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.h2};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
`

const PointWrapper = styled.div`
  text-align: right;
  @media only screen and (max-width: 720px) {
    text-align: center;
  }
`

const PointUsed = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const mapStateToProps = (state: RootState) => {
  return {
    pointInfo: selectMemberPointInfo(state),
    currentUser: selectCurrentUser(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(PointSummary)
